import { css } from '@emotion/react';

export const connectorTypeFilterStyles = {
    root: css({
        border: '1px solid #DAE7FA',
        borderRadius: '8px',
        padding: '10px 15px',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '10px',
    }),
    topBlock: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    }),
    headerWrapper: css({
        display: 'flex',
        flexDirection: 'column',
    }),
    title: css({
        fontSize: '15px',
        fontWeight: '700',
        color: '#000',
        marginBottom: '5px',
    }),
    chevronIcon: css({
        transform: 'rotate(90deg)',
        transition: 'transform 0.3s ease-in-out',
    }),
    chevronIconOpen: css({
        transform: 'rotate(-90deg)',
    }),
    contentWrapper: css({
        padding: '10px 0',
    }),
    connectorsImage: css({
        width: '100%',
    }),
    connectorsWrapper: css({
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
    }),
    connector: css({
        padding: '4px',
        borderRadius: '8px',
        backgroundColor: '#EDEDED',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '3px',
    }),
    connectorName: css({
        fontSize: '12px',
        fontWeight: '800',
        color: '#000',
    }),
};
